import React, { useState, useEffect} from 'react';

const generateZalgo = (text) => {
  const zalgoChars = [
    '\u0300', '\u0301', '\u0302', '\u0303', '\u0304', '\u0305', '\u0306', '\u0307',
    '\u0308', '\u0309', '\u030A', '\u030B', '\u030C', '\u030D', '\u030E', '\u030F',
    '\u0310', '\u0311', '\u0312', '\u0313', '\u0314', '\u0315', '\u0316', '\u0317',
    '\u0318', '\u0319', '\u031A', '\u031B', '\u031C', '\u031D', '\u031E', '\u031F',
    '\u0320', '\u0321', '\u0322', '\u0323', '\u0324', '\u0325', '\u0326', '\u0327',
    '\u0328', '\u0329', '\u032A', '\u032B', '\u032C', '\u032D', '\u032E', '\u032F',
    '\u0330', '\u0331', '\u0332', '\u0333', '\u0334', '\u0335', '\u0336', '\u0337',
    '\u0338', '\u0339', '\u033A', '\u033B', '\u033C', '\u033D', '\u033E', '\u033F',
    '\u0340', '\u0341', '\u0342', '\u0343', '\u0344', '\u0345', '\u0346', '\u0347',
    '\u0348', '\u0349', '\u034A', '\u034B', '\u034C', '\u034D', '\u034E', '\u034F',
  ];

  const zalgoify = (text) => {
    return text.split('').map(char => {
      if (Math.random() > 0.5) {
        const numberOfZalgoChars = Math.floor(Math.random() * 5) + 5;
        const zalgo = Array.from({ length: numberOfZalgoChars }, () => zalgoChars[Math.floor(Math.random() * zalgoChars.length)]).join('');
        return char + zalgo;
      }
      return char;
    }).join('');
  };

  return zalgoify(text);
};

const generateUpsideDown = (text) => {
  const upsideDownMap = {
    'a': 'ɒ', 'b': 'q', 'c': 'ɔ', 'd': 'p', 'e': 'ǝ', 'f': 'ɟ', 'g': 'ƃ',
    'h': 'ɥ', 'i': 'ᴉ', 'j': 'ɾ', 'k': 'ʞ', 'l': 'ʇ', 'm': 'ɯ', 'n': 'u',
    'o': 'o', 'p': 'd', 'q': 'b', 'r': 'ɹ', 's': 's', 't': 'ʇ', 'u': 'n',
    'v': 'ʌ', 'w': 'ʍ', 'x': 'x', 'y': 'ʎ', 'z': 'z'
  };

  return text.split('').map(char => upsideDownMap[char.toLowerCase()] || char).reverse().join('');
};

const generateMirrorText = (text) => {
  return text.split('').reverse().join('');
};

const generateCrazySymbols = (text) => {
  const symbols = ['😱', '💀', '👻', '😜', '🤪', '💩', '👽', '👹', '🦄', '🤖'];
  return text.split('').map(char => `${char}${symbols[Math.floor(Math.random() * symbols.length)]}`).join(''); 
};

const generateDecorativeText = (text) => {
  return text.split('').filter(char => char !== ' ').map(char => `『${char}』`).join('');
};

const generateBoxedText = (text) => {
  const boxChars = {
    'a': '🅰', 'b': '🅱', 'c': '🅲', 'd': '🅳', 'e': '🅴', 'f': '🅵', 'g': '🅶', 'h': '🅷', 'i': '🅸', 'j': '🅹', 'k': '🅺', 'l': '🅻',
    'm': '🅼', 'n': '🅽', 'o': '🅾', 'p': '🅿', 'q': '🆀', 'r': '🆁', 's': '🆂', 't': '🆃', 'u': '🆄', 'v': '🆅', 'w': '🆆', 'x': '🆇',
    'y': '🆈', 'z': '🆉', ' ': ' '
  };

  return text.split('').map(char => boxChars[char.toLowerCase()] || char).join('');
};

const generateBoldText = (text) => {
  const boldChars = {
    'a': '𝕒', 'b': '𝕓', 'c': '𝕔', 'd': '𝕕', 'e': '𝕖', 'f': '𝕗', 'g': '𝕘', 'h': '𝕙', 'i': '𝕚', 'j': '𝕛', 'k': '𝕜', 'l': '𝕝',
    'm': '𝕞', 'n': '𝕟', 'o': '𝕠', 'p': '𝕡', 'q': '𝕢', 'r': '𝕣', 's': '𝕤', 't': '𝕥', 'u': '𝕦', 'v': '𝕧', 'w': '𝕨', 'x': '𝕩',
    'y': '𝕪', 'z': '𝕫', 'A': '𝕬', 'B': '𝕭', 'C': '𝕮', 'D': '𝕯', 'E': '𝕰', 'F': '𝕱', 'G': '𝕲', 'H': '𝕳', 'I': '𝕴', 'J': '𝕵',
    'K': '𝕶', 'L': '𝕷', 'M': '𝕸', 'N': '𝕹', 'O': '𝕺', 'P': '𝕻', 'Q': '𝕼', 'R': '𝕽', 'S': '𝕾', 'T': '𝕿', 'U': '𝕌', 'V': '𝕍',
    'W': '𝕎', 'X': '𝕏', 'Y': '𝕐', 'Z': '𝕽', ' ': ' '
  };

  return text.split('').map(char => boldChars[char] || char).join('');
};

const generateCursiveText = (text) => {
  const cursiveChars = {
    'a': '𝓪', 'b': '𝓫', 'c': '𝓬', 'd': '𝓭', 'e': '𝓮', 'f': '𝓯', 'g': '𝓰', 'h': '𝓱', 'i': '𝓲', 'j': '𝓳', 'k': '𝓴', 'l': '𝓵',
    'm': '𝓶', 'n': '𝓷', 'o': '𝓸', 'p': '𝓹', 'q': '𝓺', 'r': '𝓻', 's': '𝓼', 't': '𝓽', 'u': '𝓾', 'v': '𝓿', 'w': '𝓌', 'x': '𝓍',
    'y': '𝓎', 'z': '𝓏', 'A': '𝓐', 'B': '𝓑', 'C': '𝓒', 'D': '𝓓', 'E': '𝓔', 'F': '𝓕', 'G': '𝓖', 'H': '𝓗', 'I': '𝓘', 'J': '𝓙',
    'K': '𝓚', 'L': '𝓛', 'M': '𝓜', 'N': '𝓝', 'O': '𝓞', 'P': '𝓟', 'Q': '𝓠', 'R': '𝓡', 'S': '𝓢', 'T': '𝓣', 'U': '𝓤', 'V': '𝓥',
    'W': '𝓦', 'X': '𝓧', 'Y': '𝓨', 'Z': '𝓩', ' ': ' '
  };

  return text.split('').map(char => cursiveChars[char] || char).join('');
};

const generateBlockyText = (text) => {
    return text.split('').map(char => `░${char}░`).join('');

  };
  const generateFrakturText = (text) => {
    const frakturChars = {
      'a': '𝖆', 'b': '𝖇', 'c': '𝖈', 'd': '𝖉', 'e': '𝖊', 'f': '𝖋', 'g': '𝖌', 'h': '𝖍', 'i': '𝖎', 'j': '𝖏', 'k': '𝖐', 'l': '𝖑',
      'm': '𝖒', 'n': '𝖓', 'o': '𝖔', 'p': '𝖕', 'q': '𝖖', 'r': '𝖗', 's': '𝖘', 't': '𝖙', 'u': '𝖚', 'v': '𝖛', 'w': '𝖜', 'x': '𝖝',
      'y': '𝖞', 'z': '𝖟', 'A': '𝕬', 'B': '𝕭', 'C': '𝕮', 'D': '𝕯', 'E': '𝕰', 'F': '𝕱', 'G': '𝕲', 'H': '𝕳', 'I': '𝕴', 'J': '𝕵',
      'K': '𝕶', 'L': '𝕷', 'M': '𝕸', 'N': '𝕹', 'O': '𝕺', 'P': '𝕻', 'Q': '𝕼', 'R': '𝕽', 'S': '𝕾', 'T': '𝕿', 'U': '𝕌', 'V': '𝕍',
      'W': '𝕎', 'X': '𝕏', 'Y': '𝕐', 'Z': '𝕶', ' ': ' '
    };
  
    return text.split('').map(char => frakturChars[char] || char).join('');
  };

const WeirdTextGenerator = () => {
  const [inputText, setInputText] = useState('');
  const [outputTexts, setOutputTexts] = useState({
    zalgo: '',
    upsideDown: '',
    mirror: '',
    crazySymbols: '',
    decorative: '',
    boxed: '',
    bold: '',
    cursive: '',
    fraktur: '',
    blocky: ''

  });
  const [previewSize, setPreviewSize] = useState(16);
  const [copyMessage, setCopyMessage] = useState('');



  useEffect(() => {
    setOutputTexts({
      fraktur: generateFrakturText(inputText),
      zalgo: generateZalgo(inputText),
      upsideDown: generateUpsideDown(inputText),
      mirror: generateMirrorText(inputText),
      crazySymbols: generateCrazySymbols(inputText),
      decorative: generateDecorativeText(inputText),
      boxed: generateBoxedText(inputText),
      bold: generateBoldText(inputText),
      cursive: generateCursiveText(inputText),
      blocky: generateBlockyText(inputText)
    });
  }, [inputText]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopyMessage('Text copied to clipboard!');
      setTimeout(() => setCopyMessage(''), 3000);
    }).catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  };

  const handlePreviewSizeChange = (e) => {
    setPreviewSize(e.target.value);
  };
 // Clear input fields
 const clearFields = () => {
  setInputText('');
  setOutputTexts('');
};


  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
     <textarea
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        rows="4"
        placeholder="Type something to generate weird text!"
        className="form-control"
      ></textarea>
      
      <div className="preview-size mb-4">
        <label htmlFor="preview-size-slider">Preview Size</label>
        <input
          id="preview-size-slider"
          type="range"
          min="12"
          max="36"
          value={previewSize}
          onChange={handlePreviewSizeChange}
          className="form-range"
        />
      </div>

<div className="mt-3">
  <h4>Zalgo Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.zalgo}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.zalgo)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Upside Down Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.upsideDown}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.upsideDown)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Mirror Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.mirror}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.mirror)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Crazy Symbols Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.crazySymbols}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.crazySymbols)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Decorative Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.decorative}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.decorative)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Boxed Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.boxed}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.boxed)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Bold Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.bold}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.bold)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Cursive Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.cursive}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.cursive)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Blocky Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.blocky}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.blocky)}>Copy to Clipboard</button>
</div>

<div className="mt-3">
  <h4>Fraktur Text</h4>
  <div className="output-box" style={{ fontSize: `${previewSize}px` }}>
  {outputTexts.fraktur}
</div>
  <button className="btn btn-primary" onClick={() => copyToClipboard(outputTexts.fraktur)}>Copy to Clipboard</button>
</div>


      {copyMessage && <div className="alert alert-success mt-3">{copyMessage}</div>}


      <button className="btn btn-danger" onClick={clearFields}>
            Clear
          </button>
    </div>
  );
};

export default WeirdTextGenerator;
